import { RoomsPage } from '@features/rooms/components/RoomsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/rooms')({
    component: RoomsPage,
    staticData: {
        crumb: {
            label: 'Rooms',
        },
    },
})
